function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Construction_site",
  transform: "translate(-717 -359)"
}, React.createElement("g", {
  id: "Group_65",
  transform: "translate(270.658 156.038)"
}, React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M1065.539,399.145l-8.093,4.687,7.514,4.386,8.117-4.7Z",
  transform: "translate(-384.748 -43.558)",
  fill: "#414141",
  opacity: 0.21
}), React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M962.175,457.862l-8.093,4.687,7.514,4.386,8.117-4.7Z",
  transform: "translate(-319.671 -80.525)",
  fill: "#414141",
  opacity: 0.21
}), React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M861.33,516.837l-8.093,4.687,7.514,4.386,8.117-4.7Z",
  transform: "translate(-256.179 -117.656)",
  fill: "#414141",
  opacity: 0.21
}), React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M759.256,575.848l-8.093,4.687,7.513,4.386,8.117-4.7Z",
  transform: "translate(-191.914 -154.809)",
  fill: "#414141",
  opacity: 0.21
}), React.createElement("path", {
  id: "Path_7",
  "data-name": "Path 7",
  d: "M655.777,635.354l-8.093,4.687,7.514,4.386,8.117-4.7Z",
  transform: "translate(-126.764 -192.274)",
  fill: "#414141",
  opacity: 0.21
}), React.createElement("path", {
  id: "Path_8",
  "data-name": "Path 8",
  d: "M556.511,692.579l-8.093,4.687,7.513,4.386,8.117-4.7Z",
  transform: "translate(-64.267 -228.302)",
  fill: "#414141",
  opacity: 0.21
}), React.createElement("path", {
  id: "Path_9",
  "data-name": "Path 9",
  d: "M454.434,751.692l-8.093,4.687,7.514,4.386,8.117-4.7Z",
  transform: "translate(0 -265.519)",
  fill: "#414141",
  opacity: 0.21
}), React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M730.863,412.178,464.121,566.2,792.2,755.788l267.113-154.236Z",
  transform: "translate(-11.194 -51.763)",
  fill: "#725758"
}), React.createElement("path", {
  id: "Path_11",
  "data-name": "Path 11",
  d: "M696.4,797.561l-57.748,33.671,93.126,54.048L789.552,851.6Z",
  transform: "translate(-121.079 -294.398)",
  fill: "#414141",
  opacity: 0.21
}), React.createElement("path", {
  id: "Path_12",
  "data-name": "Path 12",
  d: "M795.781,660.751l-57.748,33.671,93.126,54.048,57.772-33.684Z",
  transform: "translate(-183.647 -208.263)",
  fill: "#414141",
  opacity: 0.21
}), React.createElement("path", {
  id: "Path_13",
  "data-name": "Path 13",
  d: "M1445.353,873.438l-15.387,8.922,40.655,22.13,15.411-8.936Z",
  transform: "translate(-619.285 -342.17)",
  fill: "#414141",
  opacity: 0.21
}), React.createElement("path", {
  id: "Path_14",
  "data-name": "Path 14",
  d: "M1227.152,789.96l-35.1,19.884,53.052,28.929,35.125-19.9Z",
  transform: "translate(-469.495 -289.613)",
  fill: "#414141",
  opacity: 0.21
}), React.createElement("path", {
  id: "Path_15",
  "data-name": "Path 15",
  d: "M1032.117,951.157l-37.527,22.166,22.308,12.084,37.551-22.18Z",
  transform: "translate(-345.174 -391.101)",
  fill: "#414141",
  opacity: 0.21
}), React.createElement("path", {
  id: "Path_16",
  "data-name": "Path 16",
  d: "M1402.929,786.961l-15.387,8.922,40.655,22.13,15.411-8.936Z",
  transform: "translate(-592.575 -287.724)",
  fill: "#414141",
  opacity: 0.21
}), React.createElement("path", {
  id: "Path_17",
  "data-name": "Path 17",
  d: "M1183.994,412.968l328.452,189.376-56.968,32.893L1183.994,478.752Z",
  transform: "translate(-464.423 -52.26)",
  fill: "#b77351"
}), React.createElement("path", {
  id: "Path_18",
  "data-name": "Path 18",
  d: "M730.661,412.968,463.966,567.013l56.968,32.893L730.661,478.752Z",
  transform: "translate(-11.097 -52.26)",
  fill: "#d38b61"
}), React.createElement("g", {
  id: "Group_26",
  "data-name": "Group 26",
  transform: "translate(614.408 396.836)"
}, React.createElement("g", {
  id: "Group_4",
  "data-name": "Group 4",
  transform: "translate(0 23.865)"
}, React.createElement("g", {
  id: "Group_2",
  "data-name": "Group 2"
}, React.createElement("path", {
  id: "Path_19",
  "data-name": "Path 19",
  d: "M922.329,655.089l.085-.069c.077-.065.153-.132.226-.2l.037-.033c.084-.082.166-.168.245-.257.023-.025.044-.051.066-.076q.087-.1.17-.207l.071-.093c.058-.078.114-.159.169-.241.015-.022.03-.043.044-.066.071-.111.14-.226.207-.346s.129-.243.188-.37c.009-.02.018-.04.027-.06q.07-.152.134-.312l.037-.094c.024-.062.046-.128.068-.192.036-.1.071-.206.1-.312.021-.067.04-.136.059-.206.025-.089.048-.178.07-.269s.037-.156.054-.235.033-.156.047-.236.031-.177.046-.267c.011-.071.022-.142.032-.214.013-.1.025-.2.036-.3.007-.067.015-.135.021-.2.011-.118.018-.239.026-.36,0-.05.007-.1.009-.149.008-.177.013-.356.014-.54s0-.351-.01-.528c0-.06-.006-.119-.008-.179q-.009-.187-.023-.375c0-.063-.01-.127-.015-.19-.012-.132-.026-.265-.04-.4-.006-.053-.011-.1-.017-.158-.023-.185-.048-.37-.078-.557,0-.024-.008-.048-.012-.072q-.04-.243-.087-.489c-.013-.066-.027-.132-.04-.2-.026-.125-.052-.25-.08-.375-.016-.071-.033-.143-.05-.215-.029-.122-.06-.243-.091-.365-.019-.072-.037-.144-.057-.217-.035-.13-.073-.26-.111-.39-.018-.061-.035-.122-.054-.183-.057-.189-.117-.378-.18-.567l-.015-.044q-.088-.262-.184-.522c-.02-.057-.042-.113-.063-.17q-.074-.2-.152-.395l-.076-.188q-.084-.2-.172-.408c-.021-.048-.041-.1-.062-.145-.08-.183-.163-.365-.248-.546-.021-.046-.044-.091-.066-.136-.067-.14-.135-.28-.2-.419-.05-.1-.1-.2-.153-.3s-.1-.188-.147-.281q-.2-.382-.424-.757c-.05-.085-.1-.17-.151-.254-.062-.1-.123-.2-.186-.3s-.114-.18-.171-.27-.129-.2-.194-.3c-.042-.064-.085-.127-.128-.19-.181-.269-.366-.536-.558-.8l-.006-.008q-.2-.275-.413-.542-.162-.206-.329-.408l-.064-.08q-.2-.239-.4-.47c-.039-.044-.079-.087-.119-.131-.1-.108-.193-.216-.292-.32-.056-.06-.113-.119-.17-.178-.085-.089-.17-.177-.256-.264-.062-.062-.123-.123-.185-.184-.083-.082-.167-.163-.251-.242-.067-.063-.134-.125-.2-.187q-.125-.114-.25-.226l-.2-.177q-.128-.11-.258-.217l-.2-.163c-.091-.073-.182-.144-.273-.214-.062-.047-.124-.1-.186-.142-.1-.076-.2-.149-.306-.221-.053-.037-.1-.075-.157-.111-.153-.106-.307-.209-.462-.307l-.03-.018c-.159-.1-.319-.2-.479-.291-.144-.083-.288-.16-.43-.236l-.161-.083q-.161-.082-.322-.157l-.143-.067c-.151-.069-.3-.135-.452-.194s-.3-.115-.447-.166l-.142-.046q-.151-.049-.3-.093l-.174-.048c-.091-.024-.182-.047-.272-.067l-.173-.039c-.085-.017-.169-.032-.253-.047-.067-.011-.133-.024-.2-.033s-.156-.02-.233-.028-.142-.016-.212-.021-.137-.008-.2-.011c-.084,0-.167-.007-.25-.008-.115,0-.23,0-.342.006l-.034,0c-.112.006-.221.016-.331.029l-.1.011c-.12.016-.238.034-.354.058l-.091.021c-.094.021-.187.043-.278.069-.045.013-.089.028-.133.042-.073.023-.146.046-.217.072-.088.033-.174.069-.26.106-.041.018-.084.034-.125.053-.125.058-.249.122-.367.191l96.933-55.939c.119-.069.241-.132.366-.191.041-.019.085-.036.127-.054a6.309,6.309,0,0,1,4.39-.009,12.987,12.987,0,0,1,3.9,2.16l.1.084.2.163a21.523,21.523,0,0,1,7.65,14.473,9.509,9.509,0,0,1-1.107,5.678l-.013.02c-.014.023-.03.044-.045.066-.055.083-.111.163-.169.241l-.071.093q-.083.107-.17.207c-.022.026-.043.052-.066.077q-.119.133-.245.256l-.037.033c-.073.07-.149.137-.226.2l-.085.069q-.1.079-.2.153l-.084.061c-.1.065-.192.128-.292.186l-96.932,55.938c.1-.058.2-.12.292-.186l.084-.06C922.2,655.192,922.263,655.141,922.329,655.089Z",
  transform: "translate(-904.954 -574.937)",
  fill: "#d3d3d3"
}), React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1",
  transform: "translate(0 55.92)"
}, React.createElement("path", {
  id: "Path_20",
  "data-name": "Path 20",
  d: "M909.943,727.255c5.43,3.135,9.818,10.736,9.8,16.975s-4.435,8.757-9.865,5.622-9.818-10.736-9.8-16.976S904.512,724.12,909.943,727.255Z",
  transform: "translate(-900.078 -725.906)",
  fill: "#b2afad"
})), React.createElement("path", {
  id: "Path_21",
  "data-name": "Path 21",
  d: "M947.077,663.464c.021.056.043.113.063.17q.1.26.184.522l.015.044c.063.189.123.378.18.567.019.061.036.122.054.183.038.13.076.26.111.39.02.073.038.145.057.217.031.122.062.243.091.365.017.071.034.143.05.215.029.125.055.25.08.375.013.066.027.132.04.2q.047.244.087.489c0,.024.009.048.012.072.03.186.056.372.078.557.006.053.012.105.017.158.015.133.029.265.04.4.005.063.01.127.015.19q.014.188.023.375c0,.06.006.119.008.179.006.177.01.353.01.528s-.006.363-.014.54c0,.05-.006.1-.009.149-.007.121-.015.242-.026.36-.006.069-.014.136-.021.2-.011.1-.023.2-.036.3-.01.072-.021.143-.032.214q-.022.136-.046.267c-.015.08-.031.158-.047.236s-.035.157-.054.235-.046.18-.07.269q-.028.1-.059.206c-.033.106-.068.21-.1.312-.023.064-.044.13-.068.192l-.037.094q-.064.159-.134.312c-.009.02-.017.04-.027.06-.06.127-.122.251-.188.37s-.136.235-.207.346c-.014.023-.03.044-.044.066-.055.082-.111.163-.169.241l-.071.093c-.055.071-.112.14-.17.207-.022.025-.043.052-.066.076-.079.089-.161.175-.245.257l-.037.033c-.073.07-.149.137-.226.2-.028.024-.056.046-.085.069-.066.053-.133.1-.2.153l-.084.06c-.1.066-.193.128-.292.186l96.932-55.938c.1-.058.2-.121.292-.186l.084-.061c.068-.049.136-.1.2-.153l.085-.069c.077-.065.152-.132.226-.2l.036-.033c.084-.082.166-.167.245-.256l.066-.077q.087-.1.17-.207l.071-.093c.058-.078.114-.158.169-.241.015-.022.03-.044.045-.066l.013-.02a9.509,9.509,0,0,0,1.107-5.678,19.266,19.266,0,0,0-1.156-5.227L947.06,663.42Z",
  transform: "translate(-928.629 -595.408)",
  fill: "#c6c6c6"
})), React.createElement("g", {
  id: "Group_3",
  "data-name": "Group 3",
  transform: "translate(2.205 58.756)"
}, React.createElement("path", {
  id: "Path_22",
  "data-name": "Path 22",
  d: "M913.683,734.61a16.756,16.756,0,0,1,7.6,13.168c-.014,4.84-3.44,6.793-7.652,4.361a16.756,16.756,0,0,1-7.6-13.168C906.045,734.131,909.471,732.178,913.683,734.61Z",
  transform: "translate(-906.031 -733.564)",
  fill: "#755b6c"
}))), React.createElement("g", {
  id: "Group_8",
  "data-name": "Group 8",
  transform: "translate(21.009 36.03)"
}, React.createElement("g", {
  id: "Group_6",
  "data-name": "Group 6"
}, React.createElement("path", {
  id: "Path_23",
  "data-name": "Path 23",
  d: "M979.048,687.931l.085-.069c.077-.064.153-.132.226-.2l.036-.033c.084-.082.166-.168.245-.257.023-.025.044-.051.066-.077.058-.067.114-.136.169-.207l.071-.093q.087-.118.169-.241c.015-.022.03-.043.045-.066.071-.112.14-.226.207-.346s.129-.243.188-.371c.009-.019.018-.04.027-.059.047-.1.091-.206.133-.312.013-.031.025-.062.037-.093.024-.063.046-.128.068-.192.036-.1.071-.206.1-.312.021-.068.04-.137.06-.206.024-.089.048-.178.07-.269s.037-.155.053-.235.033-.156.047-.236.032-.177.046-.267c.011-.071.022-.142.032-.214q.02-.147.036-.3c.007-.068.015-.135.021-.2.011-.119.019-.239.026-.36,0-.05.007-.1.009-.149.008-.177.013-.357.013-.54s0-.351-.01-.528c0-.06-.005-.119-.009-.179-.005-.124-.013-.25-.023-.375,0-.063-.01-.127-.015-.19-.011-.132-.025-.264-.04-.4-.006-.052-.011-.1-.017-.158-.023-.185-.048-.37-.078-.557,0-.024-.009-.048-.012-.071q-.04-.244-.087-.489c-.013-.066-.027-.131-.04-.2-.026-.125-.052-.25-.08-.375q-.025-.108-.05-.215c-.029-.121-.06-.243-.091-.365-.019-.072-.037-.144-.057-.217q-.053-.2-.111-.39c-.018-.061-.035-.122-.054-.183-.057-.189-.117-.378-.18-.567,0-.014-.01-.029-.015-.044q-.088-.261-.184-.521c-.021-.057-.042-.113-.064-.169-.05-.132-.1-.264-.153-.4l-.075-.187q-.084-.2-.172-.408c-.021-.048-.041-.1-.062-.145q-.12-.274-.248-.546c-.021-.046-.044-.091-.066-.137-.067-.14-.135-.28-.2-.419-.05-.1-.1-.2-.152-.3s-.1-.188-.147-.281q-.2-.382-.425-.756c-.05-.085-.1-.17-.151-.254q-.092-.153-.185-.3c-.056-.09-.114-.18-.171-.27s-.128-.2-.194-.3c-.042-.063-.085-.127-.128-.19-.182-.269-.366-.535-.558-.8l-.006-.008q-.2-.274-.413-.542c-.108-.138-.218-.273-.329-.408l-.065-.08q-.2-.239-.4-.47c-.039-.044-.079-.087-.119-.131-.1-.108-.193-.215-.291-.32l-.17-.178c-.085-.089-.17-.177-.256-.264-.062-.062-.123-.123-.186-.183-.083-.081-.166-.163-.25-.243l-.2-.187c-.083-.076-.166-.152-.25-.226l-.2-.177q-.128-.11-.258-.217c-.066-.055-.133-.109-.2-.163-.09-.073-.181-.144-.273-.214l-.186-.142q-.152-.113-.306-.221c-.052-.037-.1-.075-.157-.111-.153-.106-.307-.209-.462-.307l-.03-.018c-.159-.1-.319-.2-.479-.291-.144-.083-.288-.16-.43-.236l-.161-.084q-.162-.082-.321-.157l-.143-.067c-.151-.069-.3-.135-.452-.195s-.3-.114-.447-.166c-.048-.017-.095-.031-.142-.046q-.151-.049-.3-.093l-.174-.048c-.091-.024-.182-.047-.272-.067l-.173-.039c-.085-.018-.169-.033-.253-.047-.067-.011-.133-.023-.2-.033s-.156-.02-.233-.028-.142-.016-.212-.021-.136-.008-.2-.011c-.084,0-.167-.007-.25-.008-.115,0-.23,0-.342.005l-.034,0c-.111.006-.221.016-.33.029l-.1.011c-.12.016-.238.034-.354.058-.031.006-.061.015-.092.022-.094.021-.187.043-.278.068-.045.013-.088.028-.133.042-.073.023-.146.046-.217.072-.088.032-.174.069-.26.106-.042.018-.085.034-.126.054-.126.059-.249.122-.368.191l96.933-55.939c.119-.069.241-.132.366-.19.042-.02.085-.036.127-.054a6.307,6.307,0,0,1,4.39-.01,12.99,12.99,0,0,1,3.9,2.16c.035.027.069.057.1.084l.2.163a21.527,21.527,0,0,1,7.651,14.473,9.507,9.507,0,0,1-1.107,5.678l-.013.02-.045.067c-.055.082-.111.163-.169.24l-.071.093c-.055.071-.111.14-.169.207-.022.026-.043.052-.066.077q-.119.133-.245.256l-.037.033c-.073.07-.149.137-.226.2l-.085.069c-.066.053-.133.1-.2.153-.028.02-.056.041-.085.06-.1.065-.192.128-.292.186L978.47,688.33c.1-.058.2-.121.292-.186l.085-.06C978.915,688.034,978.982,687.984,979.048,687.931Z",
  transform: "translate(-961.673 -607.779)",
  fill: "#d3d3d3"
}), React.createElement("g", {
  id: "Group_5",
  "data-name": "Group 5",
  transform: "translate(0 55.92)"
}, React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M966.662,760.1c5.43,3.135,9.818,10.736,9.8,16.976s-4.435,8.757-9.865,5.622-9.818-10.735-9.8-16.976S961.231,756.962,966.662,760.1Z",
  transform: "translate(-956.797 -758.748)",
  fill: "#b2afad"
})), React.createElement("path", {
  id: "Path_25",
  "data-name": "Path 25",
  d: "M1003.8,696.306c.021.057.043.113.064.17q.1.26.184.522l.015.044c.063.189.123.378.18.567.019.061.036.122.054.183q.057.2.111.39c.02.072.038.144.057.217.031.122.062.243.091.364q.026.107.05.215c.029.125.055.25.08.375.013.066.027.132.04.2q.047.245.087.489c0,.024.008.048.012.071.029.186.055.372.078.557.007.053.012.106.017.158.015.133.029.265.04.4.005.063.01.127.015.19.009.126.017.25.023.375,0,.06.007.119.009.179.007.177.011.353.01.528s-.006.363-.013.54c0,.05-.006.1-.009.149-.007.122-.015.242-.026.36-.006.068-.014.136-.021.2q-.016.15-.036.3c-.01.072-.021.143-.032.214-.014.09-.03.179-.046.267s-.031.158-.047.236-.035.157-.053.235-.046.181-.07.269c-.019.069-.039.138-.06.206-.032.106-.067.21-.1.312-.023.064-.044.129-.068.192-.012.031-.024.063-.037.093-.043.106-.087.211-.133.312-.009.02-.017.04-.027.059q-.089.191-.188.371c-.067.12-.136.235-.207.346-.015.023-.03.044-.045.066q-.082.124-.169.242l-.071.093c-.055.071-.111.14-.169.207-.022.026-.043.052-.066.077-.079.089-.161.175-.245.257l-.036.033c-.073.07-.149.137-.226.2l-.085.069c-.066.053-.133.1-.2.153l-.085.06c-.1.065-.192.128-.292.186l96.932-55.938c.1-.058.2-.121.292-.186.029-.019.057-.04.085-.06.068-.049.136-.1.2-.153l.085-.069c.077-.065.152-.132.226-.2l.037-.033q.126-.123.245-.256c.023-.025.044-.051.066-.077.058-.067.115-.136.169-.207l.071-.093c.058-.078.114-.158.169-.24l.045-.067.013-.02a9.508,9.508,0,0,0,1.107-5.678,19.278,19.278,0,0,0-1.156-5.227l-96.951,55.968Z",
  transform: "translate(-985.348 -628.25)",
  fill: "#c6c6c6"
})), React.createElement("g", {
  id: "Group_7",
  "data-name": "Group 7",
  transform: "translate(2.206 58.756)"
}, React.createElement("path", {
  id: "Path_26",
  "data-name": "Path 26",
  d: "M970.4,767.453a16.754,16.754,0,0,1,7.6,13.168c-.013,4.84-3.44,6.792-7.652,4.36a16.755,16.755,0,0,1-7.6-13.168C962.765,766.974,966.192,765.021,970.4,767.453Z",
  transform: "translate(-962.752 -766.407)",
  fill: "#755b6c"
}))), React.createElement("g", {
  id: "Group_12",
  "data-name": "Group 12",
  transform: "translate(37.945 48.195)"
}, React.createElement("g", {
  id: "Group_10",
  "data-name": "Group 10"
}, React.createElement("path", {
  id: "Path_27",
  "data-name": "Path 27",
  d: "M1035.768,720.773l.085-.069c.077-.065.152-.132.226-.2l.036-.034c.084-.082.166-.168.245-.256l.066-.077q.087-.1.169-.207l.071-.093c.058-.078.114-.159.169-.241.015-.022.03-.044.044-.066.071-.111.141-.226.207-.346s.129-.243.188-.371c.009-.019.017-.04.027-.06q.069-.152.133-.312l.037-.093c.024-.063.046-.128.068-.193.036-.1.071-.206.1-.312.021-.067.04-.136.06-.206.024-.088.048-.178.07-.269s.037-.156.054-.235.032-.156.047-.236.032-.177.046-.267c.011-.071.022-.142.032-.214.014-.1.026-.2.036-.3.007-.067.015-.135.021-.2.011-.118.019-.239.026-.36,0-.05.007-.1.009-.149.008-.177.013-.357.013-.54s0-.352-.01-.528c0-.059-.005-.119-.009-.179q-.009-.187-.022-.375c0-.064-.01-.127-.015-.19-.011-.132-.025-.264-.04-.4-.006-.053-.011-.105-.018-.158q-.034-.278-.078-.557c0-.024-.009-.048-.013-.071q-.04-.244-.087-.489c-.013-.066-.027-.132-.04-.2-.026-.125-.052-.25-.08-.375-.016-.072-.033-.144-.05-.216-.029-.121-.059-.243-.091-.364-.019-.072-.037-.145-.057-.217-.035-.13-.073-.26-.111-.391-.018-.061-.035-.122-.053-.183q-.086-.283-.18-.567l-.016-.044c-.058-.174-.12-.348-.183-.522-.021-.057-.043-.113-.064-.169q-.074-.2-.153-.395-.037-.094-.076-.187c-.056-.137-.113-.273-.171-.409-.021-.048-.041-.1-.062-.145-.081-.183-.163-.365-.248-.546-.021-.046-.044-.091-.066-.137-.067-.14-.135-.28-.2-.419-.05-.1-.1-.2-.152-.295s-.1-.188-.147-.282q-.205-.382-.425-.757c-.05-.085-.1-.169-.151-.254-.062-.1-.123-.2-.185-.3s-.114-.18-.171-.27-.128-.2-.194-.3c-.042-.064-.085-.127-.128-.19-.181-.269-.367-.535-.558-.8l-.006-.008q-.2-.274-.413-.541c-.108-.138-.218-.274-.329-.409l-.065-.08c-.132-.159-.267-.316-.4-.47-.039-.044-.079-.087-.118-.132-.1-.108-.194-.215-.292-.32-.056-.06-.113-.119-.17-.178-.085-.089-.17-.177-.256-.264l-.186-.183q-.125-.123-.251-.243c-.067-.063-.134-.125-.2-.187q-.125-.115-.25-.226c-.068-.06-.135-.119-.2-.177q-.128-.111-.258-.218l-.2-.163c-.091-.073-.182-.144-.273-.214l-.186-.142c-.1-.076-.2-.149-.306-.221l-.157-.112c-.153-.106-.307-.208-.462-.307l-.029-.018q-.238-.151-.48-.291c-.144-.083-.287-.161-.43-.236l-.161-.083c-.108-.055-.215-.107-.322-.157l-.143-.067c-.151-.069-.3-.134-.452-.194s-.3-.115-.447-.166l-.142-.047c-.1-.033-.2-.064-.3-.093l-.174-.048c-.091-.024-.182-.047-.272-.068l-.173-.039c-.085-.018-.169-.033-.253-.047-.067-.011-.133-.023-.2-.033s-.156-.02-.233-.028-.142-.016-.212-.022-.137-.008-.2-.011c-.084,0-.167-.008-.25-.009-.115,0-.23,0-.342.005l-.034,0c-.111.006-.221.017-.33.029l-.1.011c-.12.016-.238.035-.354.059-.031.006-.061.015-.092.022-.094.021-.187.043-.278.068-.045.013-.089.028-.133.042-.073.023-.146.046-.217.073-.089.032-.174.068-.26.106-.042.018-.084.034-.126.053-.125.059-.248.122-.367.191l96.933-55.939c.119-.069.241-.132.366-.19.042-.019.084-.036.127-.054a6.3,6.3,0,0,1,4.39-.009,12.981,12.981,0,0,1,3.9,2.16c.035.027.069.056.1.084l.2.163a21.522,21.522,0,0,1,7.651,14.473,9.512,9.512,0,0,1-1.107,5.678l-.013.019c-.014.023-.03.044-.045.067-.054.082-.111.162-.169.24-.023.031-.047.062-.071.093-.055.071-.111.14-.169.207l-.066.076c-.079.089-.161.175-.245.257l-.036.033q-.111.1-.226.2l-.085.069c-.066.053-.133.1-.2.153l-.085.06c-.1.065-.192.128-.292.186l-96.932,55.939c.1-.058.2-.121.292-.186.029-.019.056-.04.085-.06C1035.635,720.877,1035.7,720.826,1035.768,720.773Z",
  transform: "translate(-1014.32 -640.621)",
  fill: "#d3d3d3"
}), React.createElement("g", {
  id: "Group_9",
  "data-name": "Group 9",
  transform: "translate(0 52.549)"
}, React.createElement("ellipse", {
  id: "Ellipse_2",
  "data-name": "Ellipse 2",
  cx: 8.028,
  cy: 13.861,
  rx: 8.028,
  ry: 13.861,
  transform: "translate(0 8.068) rotate(-30.163)",
  fill: "#b2afad"
})), React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M1060.517,729.149c.021.056.043.113.064.169.063.174.125.347.183.522l.016.044q.094.283.18.567c.019.061.036.122.053.183.038.13.076.26.111.39l.057.217c.031.122.062.243.091.364l.05.215q.042.188.08.375c.014.066.027.132.04.2q.047.245.087.489c0,.024.009.048.013.072q.044.279.078.557c.006.053.011.105.018.157.015.133.029.265.04.4.005.063.01.127.015.19q.014.188.022.375c0,.06.007.119.009.179.006.177.011.353.01.528s-.006.363-.013.54c0,.05-.007.1-.009.149-.007.121-.015.242-.026.36-.006.068-.014.136-.021.2-.01.1-.022.2-.036.3-.01.072-.021.144-.032.214q-.021.135-.046.267t-.047.236c-.017.079-.035.157-.054.235s-.046.181-.07.269c-.019.069-.039.138-.06.206-.033.106-.068.21-.1.312-.023.064-.044.13-.068.193l-.037.093q-.064.159-.133.312c-.009.02-.017.04-.027.06q-.09.191-.188.37c-.067.121-.136.235-.207.346-.014.022-.03.044-.044.066-.055.082-.111.163-.169.241l-.07.093c-.056.071-.112.14-.17.207l-.066.077c-.079.089-.161.175-.245.257l-.036.034q-.11.1-.226.2l-.085.069c-.066.053-.133.1-.2.153l-.085.06c-.1.065-.192.128-.292.186l96.932-55.939c.1-.058.2-.12.292-.186l.085-.06c.068-.049.135-.1.2-.153l.085-.069c.077-.064.152-.132.226-.2l.036-.033c.084-.082.166-.168.245-.257l.066-.076c.058-.067.115-.136.169-.207.024-.031.048-.062.071-.093.058-.078.115-.159.169-.24.015-.023.031-.044.045-.067l.013-.019a9.512,9.512,0,0,0,1.107-5.678,19.261,19.261,0,0,0-1.156-5.227L1060.5,729.1Z",
  transform: "translate(-1037.995 -661.093)",
  fill: "#c6c6c6"
})), React.createElement("g", {
  id: "Group_11",
  "data-name": "Group 11",
  transform: "translate(6.278 58.756)"
}, React.createElement("path", {
  id: "Path_29",
  "data-name": "Path 29",
  d: "M1027.123,800.3a16.755,16.755,0,0,1,7.6,13.168c-.014,4.84-3.44,6.793-7.652,4.361a16.755,16.755,0,0,1-7.6-13.168C1019.485,799.815,1022.911,797.863,1027.123,800.3Z",
  transform: "translate(-1019.471 -799.249)",
  fill: "#755b6c"
}))), React.createElement("g", {
  id: "Group_21",
  "data-name": "Group 21",
  transform: "translate(11.021 11.418)"
}, React.createElement("g", {
  id: "Group_16",
  "data-name": "Group 16"
}, React.createElement("g", {
  id: "Group_14",
  "data-name": "Group 14"
}, React.createElement("path", {
  id: "Path_30",
  "data-name": "Path 30",
  d: "M952.084,620.478l.085-.069c.077-.065.153-.131.226-.2l.037-.033c.084-.082.166-.168.245-.257l.066-.077q.087-.1.17-.207l.071-.093c.058-.078.114-.159.168-.241l.045-.066c.071-.111.14-.225.207-.346s.129-.243.189-.37l.027-.06c.047-.1.091-.206.133-.312.013-.031.025-.062.037-.093.024-.063.046-.128.069-.193.036-.1.071-.206.1-.312.021-.068.04-.137.06-.206.024-.088.048-.178.07-.269s.037-.156.053-.235.033-.156.047-.235.032-.177.046-.267q.017-.106.032-.214c.013-.1.025-.2.036-.3.007-.067.015-.135.021-.2.011-.118.019-.239.026-.36,0-.05.007-.1.009-.149.008-.177.013-.356.014-.54s0-.351-.01-.528c0-.059-.006-.119-.009-.179-.006-.125-.013-.25-.023-.375,0-.063-.01-.127-.015-.19q-.017-.2-.04-.4c-.006-.053-.011-.105-.017-.158-.023-.185-.049-.371-.078-.557,0-.024-.009-.047-.012-.071q-.039-.244-.087-.489c-.013-.066-.027-.132-.04-.2-.026-.125-.052-.25-.08-.375-.016-.071-.033-.143-.05-.215-.029-.122-.06-.243-.091-.364-.018-.073-.037-.145-.057-.217q-.053-.2-.111-.391c-.018-.061-.035-.122-.054-.183-.057-.189-.117-.378-.18-.567,0-.015-.01-.029-.015-.044q-.088-.261-.184-.522c-.021-.057-.043-.113-.064-.169q-.075-.2-.153-.4c-.025-.063-.05-.125-.075-.187q-.084-.2-.172-.408c-.021-.049-.041-.1-.063-.146q-.12-.273-.248-.546c-.021-.046-.044-.091-.066-.137q-.1-.211-.2-.419c-.05-.1-.1-.2-.153-.295s-.1-.188-.147-.282q-.2-.382-.424-.757c-.05-.085-.1-.169-.151-.254q-.092-.153-.185-.3c-.056-.09-.114-.18-.171-.27s-.128-.2-.194-.3c-.042-.064-.085-.127-.128-.19-.182-.269-.367-.535-.558-.8l-.006-.008q-.2-.274-.413-.542c-.108-.138-.218-.273-.329-.408l-.065-.08q-.2-.239-.4-.471l-.119-.131c-.1-.108-.193-.215-.292-.32-.056-.06-.113-.119-.17-.178-.085-.089-.17-.177-.256-.264-.062-.062-.123-.123-.185-.183q-.125-.123-.251-.243-.1-.094-.2-.187-.124-.114-.25-.227c-.067-.06-.135-.119-.2-.177-.086-.074-.171-.146-.258-.218l-.2-.163c-.09-.073-.181-.143-.273-.214-.062-.048-.124-.1-.186-.142-.1-.076-.2-.149-.306-.221l-.157-.111c-.153-.106-.307-.208-.462-.307l-.03-.018c-.159-.1-.319-.2-.479-.29-.145-.084-.288-.161-.43-.236l-.161-.083c-.108-.055-.215-.107-.322-.157l-.143-.067c-.152-.069-.3-.134-.452-.194s-.3-.115-.447-.166l-.142-.046c-.1-.033-.2-.064-.3-.093L942,596.5q-.137-.037-.272-.068l-.173-.038c-.085-.018-.169-.033-.253-.047-.067-.011-.133-.023-.2-.033s-.156-.02-.233-.029-.142-.016-.212-.021-.136-.008-.2-.011c-.084,0-.167-.008-.25-.008-.115,0-.229,0-.342.005l-.035,0c-.111.007-.221.017-.33.03l-.1.011c-.12.016-.238.035-.354.058l-.092.022c-.093.021-.186.043-.278.068-.044.013-.088.028-.132.042-.073.023-.146.046-.217.073-.089.032-.174.069-.26.106-.041.018-.084.034-.125.053-.126.059-.249.122-.368.192l95.178-54.934c.119-.069.241-.132.366-.19.042-.019.084-.036.127-.054a6.305,6.305,0,0,1,4.39-.009,12.973,12.973,0,0,1,3.9,2.16l.1.084c.067.053.133.108.2.163a21.525,21.525,0,0,1,7.65,14.473,9.513,9.513,0,0,1-1.107,5.678l-.013.02c-.014.023-.03.044-.045.066q-.082.123-.168.241l-.071.093q-.083.107-.17.207l-.066.077c-.08.089-.161.174-.245.256l-.036.033c-.074.07-.149.137-.226.2l-.085.069c-.066.053-.133.1-.2.153-.028.02-.056.041-.085.06-.1.065-.192.128-.292.186l-95.177,54.933c.1-.058.2-.121.292-.186.028-.019.057-.04.085-.06C951.951,620.582,952.018,620.53,952.084,620.478Z",
  transform: "translate(-934.709 -541.331)",
  fill: "#d3d3d3"
}), React.createElement("g", {
  id: "Group_13",
  "data-name": "Group 13",
  transform: "translate(0 54.914)"
}, React.createElement("path", {
  id: "Path_31",
  "data-name": "Path 31",
  d: "M939.7,690.935c5.43,3.135,9.818,10.735,9.8,16.975s-4.434,8.757-9.865,5.622-9.818-10.735-9.8-16.975S934.267,687.8,939.7,690.935Z",
  transform: "translate(-929.833 -689.587)",
  fill: "#b2afad"
})), React.createElement("path", {
  id: "Path_32",
  "data-name": "Path 32",
  d: "M976.833,628.853c.021.056.043.113.064.169q.1.261.184.522c0,.015.01.029.015.044.063.189.123.378.18.567.019.061.036.122.054.183q.057.2.111.39c.02.072.038.144.057.217.031.122.062.243.091.364q.026.108.05.215c.029.125.055.25.08.375.013.066.027.132.04.2q.047.245.087.489c0,.024.009.048.012.071.03.186.055.372.078.557.007.053.012.105.017.157.015.133.029.265.04.4.006.063.01.127.015.19.009.126.017.25.023.375,0,.06.006.119.008.178.006.177.01.353.01.528s-.006.363-.014.54c0,.05-.006.1-.009.149-.007.122-.015.242-.026.36-.006.069-.014.136-.021.2-.011.1-.023.2-.036.3-.01.072-.021.144-.032.214-.014.09-.03.179-.046.267s-.031.157-.047.235-.035.157-.053.235-.046.181-.07.269c-.019.069-.039.138-.06.206-.032.106-.067.21-.1.311-.023.065-.044.13-.068.193-.012.031-.024.062-.037.093-.043.106-.087.21-.133.312l-.027.06q-.089.191-.189.37c-.067.121-.135.235-.207.346l-.045.066q-.082.124-.169.241l-.071.093c-.055.071-.112.14-.17.207l-.066.077c-.079.089-.161.175-.245.257l-.037.033c-.073.07-.149.137-.226.2l-.085.069c-.066.053-.133.1-.2.153l-.085.06c-.1.065-.192.128-.292.186l95.177-54.933c.1-.058.2-.121.292-.186.029-.019.057-.04.085-.06.068-.049.136-.1.2-.153l.085-.069c.077-.065.152-.132.226-.2l.036-.033c.084-.082.166-.168.245-.256l.066-.077q.086-.1.17-.207l.071-.093q.087-.117.168-.241c.015-.022.031-.044.045-.066l.013-.02a9.512,9.512,0,0,0,1.107-5.678,19.262,19.262,0,0,0-1.156-5.227l-95.2,54.963Z",
  transform: "translate(-958.384 -561.802)",
  fill: "#c6c6c6"
})), React.createElement("g", {
  id: "Group_15",
  "data-name": "Group 15",
  transform: "translate(2.205 57.751)"
}, React.createElement("path", {
  id: "Path_33",
  "data-name": "Path 33",
  d: "M943.439,698.291a16.756,16.756,0,0,1,7.6,13.168c-.014,4.84-3.44,6.793-7.652,4.361a16.757,16.757,0,0,1-7.6-13.168C935.8,697.811,939.227,695.859,943.439,698.291Z",
  transform: "translate(-935.787 -697.244)",
  fill: "#755b6c"
}))), React.createElement("g", {
  id: "Group_20",
  "data-name": "Group 20",
  transform: "translate(21.009 12.165)"
}, React.createElement("g", {
  id: "Group_18",
  "data-name": "Group 18"
}, React.createElement("path", {
  id: "Path_34",
  "data-name": "Path 34",
  d: "M1008.8,653.32c.029-.023.057-.045.085-.069q.116-.1.226-.2l.036-.033c.084-.082.166-.168.245-.257l.066-.077c.058-.067.114-.136.169-.207.024-.031.048-.061.071-.093.058-.078.115-.159.169-.242.015-.022.03-.043.044-.066.072-.111.141-.226.207-.346s.129-.243.188-.37c.009-.02.018-.04.027-.06.046-.1.091-.206.133-.312l.037-.094c.024-.063.046-.128.069-.192.036-.1.071-.206.1-.312.021-.068.04-.136.06-.206.024-.088.048-.178.07-.269s.037-.155.053-.234.033-.156.047-.236.032-.177.046-.267c.011-.071.022-.142.032-.215.014-.1.026-.2.036-.3.007-.067.015-.134.021-.2.011-.118.019-.239.026-.36,0-.05.007-.1.009-.149.008-.177.013-.357.014-.54s0-.351-.01-.528c0-.059-.006-.119-.009-.179q-.009-.187-.023-.375c0-.063-.01-.126-.015-.19-.012-.132-.025-.264-.04-.4-.006-.053-.011-.1-.017-.158-.023-.185-.048-.37-.078-.557,0-.023-.009-.047-.013-.072q-.04-.244-.087-.489c-.013-.066-.027-.132-.04-.2-.026-.125-.052-.25-.08-.375-.016-.072-.033-.143-.05-.215-.029-.121-.059-.243-.091-.364-.019-.073-.037-.144-.057-.217-.035-.13-.073-.26-.111-.39-.018-.061-.035-.122-.053-.183q-.086-.284-.18-.567l-.016-.044q-.088-.261-.183-.521c-.021-.057-.043-.113-.064-.17-.05-.132-.1-.263-.153-.395l-.076-.188c-.056-.136-.113-.272-.171-.408-.021-.048-.041-.1-.062-.145q-.121-.274-.248-.546c-.021-.046-.044-.091-.066-.137-.067-.14-.135-.28-.2-.419-.05-.1-.1-.2-.152-.3s-.1-.188-.147-.281q-.2-.382-.424-.757c-.05-.085-.1-.17-.151-.254-.062-.1-.123-.2-.185-.3s-.114-.18-.171-.27-.128-.2-.194-.3c-.042-.064-.085-.127-.128-.19-.182-.269-.367-.535-.558-.8l-.006-.008q-.2-.274-.413-.542-.162-.207-.329-.408l-.065-.08q-.2-.239-.4-.471l-.118-.131c-.1-.108-.193-.215-.292-.32-.056-.06-.113-.119-.17-.178-.085-.089-.17-.177-.256-.264-.062-.062-.123-.123-.186-.183q-.125-.123-.251-.243c-.067-.063-.134-.125-.2-.187q-.125-.114-.25-.226l-.2-.177q-.128-.111-.258-.218c-.066-.055-.133-.109-.2-.163-.091-.073-.182-.144-.273-.214-.062-.047-.124-.1-.186-.142-.1-.076-.2-.149-.306-.221l-.157-.112c-.153-.106-.307-.209-.462-.307l-.029-.018c-.159-.1-.319-.2-.48-.291-.145-.083-.287-.16-.43-.236l-.161-.083q-.162-.082-.322-.157l-.143-.067c-.152-.069-.3-.134-.452-.194s-.3-.115-.447-.166l-.142-.046c-.1-.033-.2-.064-.3-.093l-.174-.048q-.137-.037-.272-.068c-.057-.013-.116-.027-.173-.038-.085-.018-.169-.033-.253-.047-.067-.011-.133-.023-.2-.033s-.156-.02-.233-.029-.142-.016-.212-.021-.137-.007-.2-.011c-.084,0-.167-.007-.25-.008-.115,0-.23,0-.342.005l-.034,0c-.112.006-.222.017-.33.029l-.1.011c-.12.016-.238.035-.354.058l-.092.022c-.093.021-.186.043-.277.069-.045.013-.089.028-.133.042-.073.023-.146.046-.217.073-.088.032-.175.069-.26.106-.041.018-.084.034-.126.053-.125.059-.248.122-.367.191l95.178-54.933c.118-.069.241-.132.365-.19.042-.02.084-.036.126-.054a6.31,6.31,0,0,1,4.39-.009,13,13,0,0,1,3.9,2.16c.035.027.069.056.1.084l.2.163a21.525,21.525,0,0,1,7.65,14.473,9.508,9.508,0,0,1-1.107,5.678l-.013.02-.045.067c-.055.082-.111.162-.169.24l-.071.093c-.055.071-.112.14-.17.207l-.066.077c-.08.089-.161.175-.245.257l-.036.033q-.111.1-.226.2l-.085.069c-.066.053-.133.1-.2.153l-.084.06c-.1.065-.192.128-.292.186l-95.176,54.932c.1-.058.2-.121.292-.186l.085-.061C1008.671,653.424,1008.738,653.373,1008.8,653.32Z",
  transform: "translate(-991.429 -574.174)",
  fill: "#d3d3d3"
}), React.createElement("g", {
  id: "Group_17",
  "data-name": "Group 17",
  transform: "translate(0 54.914)"
}, React.createElement("path", {
  id: "Path_35",
  "data-name": "Path 35",
  d: "M996.417,723.778c5.431,3.135,9.819,10.735,9.8,16.975s-4.434,8.757-9.865,5.622-9.818-10.735-9.8-16.975S990.987,720.643,996.417,723.778Z",
  transform: "translate(-986.553 -722.429)",
  fill: "#b2afad"
})), React.createElement("path", {
  id: "Path_36",
  "data-name": "Path 36",
  d: "M1033.553,661.7c.021.057.043.113.064.17q.1.26.183.522l.016.044c.063.189.123.377.18.567.019.061.036.122.053.183.038.13.076.26.111.39.02.073.038.144.057.217.031.121.062.243.091.364.017.072.034.143.05.215.028.125.054.25.08.375.014.066.028.132.04.2q.047.244.087.489c0,.024.009.048.013.071.029.187.055.372.078.557.006.053.011.105.017.158q.023.2.04.4c.005.064.01.127.015.19q.014.188.023.375c0,.06.007.12.009.179.006.177.011.353.01.528s-.005.364-.014.54c0,.051-.006.1-.009.149-.007.122-.015.242-.026.36-.006.069-.014.136-.021.2-.01.1-.022.2-.036.3-.01.072-.021.144-.032.214-.014.09-.03.179-.046.267s-.031.157-.047.235-.035.157-.053.234-.046.181-.07.27c-.019.069-.039.138-.06.206-.033.106-.068.21-.1.312-.023.064-.044.13-.068.192l-.037.094c-.043.106-.087.21-.133.312-.009.02-.017.04-.027.06-.06.127-.122.251-.188.37s-.136.235-.207.346c-.014.023-.03.044-.044.066-.054.083-.111.163-.169.241-.023.031-.047.062-.071.093-.055.071-.112.14-.169.207l-.066.076q-.119.133-.245.257l-.036.033q-.111.105-.226.2c-.028.024-.057.046-.085.069q-.1.079-.2.153l-.085.061c-.1.065-.192.128-.292.186l95.176-54.932c.1-.058.2-.121.292-.186l.084-.06q.1-.074.2-.153l.085-.069c.077-.065.152-.132.226-.2l.036-.033c.084-.082.166-.168.245-.257l.066-.077c.058-.067.115-.136.17-.207.024-.031.048-.062.071-.093.058-.078.114-.158.169-.24l.045-.067.013-.02a9.509,9.509,0,0,0,1.107-5.678,19.278,19.278,0,0,0-1.156-5.227l-95.2,54.962Z",
  transform: "translate(-1015.104 -594.645)",
  fill: "#c6c6c6"
})), React.createElement("g", {
  id: "Group_19",
  "data-name": "Group 19",
  transform: "translate(2.205 57.751)"
}, React.createElement("path", {
  id: "Path_37",
  "data-name": "Path 37",
  d: "M1000.159,731.133a16.756,16.756,0,0,1,7.6,13.168c-.014,4.84-3.44,6.793-7.652,4.361a16.755,16.755,0,0,1-7.6-13.168C992.521,730.654,995.947,728.7,1000.159,731.133Z",
  transform: "translate(-992.507 -730.087)",
  fill: "#755b6c"
})))), React.createElement("g", {
  id: "Group_25",
  "data-name": "Group 25",
  transform: "translate(22.443)"
}, React.createElement("g", {
  id: "Group_23",
  "data-name": "Group 23"
}, React.createElement("path", {
  id: "Path_38",
  "data-name": "Path 38",
  d: "M982.919,587.273,983,587.2q.116-.1.226-.2l.036-.033c.084-.082.166-.168.245-.257l.066-.077q.087-.1.17-.207c.024-.031.048-.061.071-.093q.087-.117.169-.241l.045-.066c.071-.111.14-.226.207-.346s.129-.243.188-.37l.027-.06c.047-.1.091-.205.133-.312.013-.031.025-.062.037-.094.024-.063.046-.128.068-.192.036-.1.071-.206.1-.312.021-.068.04-.137.06-.206.024-.089.048-.178.07-.269s.037-.156.054-.235.033-.156.047-.235.032-.177.046-.267c.011-.071.022-.142.032-.215.013-.1.025-.2.036-.3.007-.067.015-.134.021-.2.01-.118.018-.239.026-.36,0-.05.007-.1.009-.149.008-.177.013-.356.014-.54s0-.351-.01-.528c0-.059-.006-.119-.009-.179q-.009-.187-.023-.375c0-.063-.01-.127-.015-.19-.012-.132-.025-.264-.04-.4-.006-.052-.011-.1-.017-.157-.023-.185-.049-.371-.078-.557,0-.024-.009-.048-.012-.072-.026-.163-.055-.325-.087-.489-.013-.066-.027-.132-.04-.2-.026-.125-.052-.25-.08-.375q-.025-.108-.05-.216c-.029-.121-.06-.243-.091-.364-.019-.072-.037-.144-.057-.217q-.053-.2-.111-.39c-.018-.061-.035-.122-.053-.183-.057-.189-.117-.378-.18-.567l-.015-.044q-.088-.261-.184-.522c-.02-.057-.042-.113-.063-.169q-.074-.2-.153-.4l-.075-.187q-.084-.2-.172-.408c-.021-.049-.041-.1-.062-.145q-.12-.274-.248-.546c-.021-.046-.044-.091-.066-.137-.067-.14-.135-.28-.2-.419-.05-.1-.1-.2-.153-.3s-.1-.188-.147-.281q-.2-.382-.424-.757c-.05-.085-.1-.17-.151-.254-.061-.1-.123-.2-.186-.3s-.113-.18-.171-.27-.129-.2-.194-.3c-.042-.064-.085-.127-.128-.19-.182-.269-.367-.535-.558-.8l-.006-.008q-.2-.274-.413-.542c-.108-.138-.218-.273-.329-.408l-.065-.08q-.2-.239-.4-.47l-.119-.131c-.1-.107-.193-.215-.292-.32-.056-.06-.113-.119-.17-.178-.085-.089-.17-.177-.256-.264-.061-.062-.123-.123-.186-.183-.083-.081-.166-.163-.25-.243l-.2-.187q-.125-.114-.25-.226l-.2-.177q-.128-.11-.258-.217l-.2-.163q-.136-.109-.273-.214l-.186-.142c-.1-.076-.2-.148-.306-.221l-.157-.112c-.153-.105-.307-.208-.462-.307l-.03-.018c-.158-.1-.318-.2-.479-.291-.144-.083-.288-.16-.43-.236l-.161-.083c-.108-.055-.215-.107-.322-.157l-.143-.067c-.151-.069-.3-.134-.452-.194s-.3-.115-.447-.166l-.142-.046q-.151-.05-.3-.093l-.174-.048c-.091-.024-.182-.047-.272-.067l-.173-.039c-.085-.018-.169-.033-.253-.047-.067-.011-.133-.023-.2-.033s-.156-.02-.233-.028-.142-.016-.212-.021-.136-.008-.2-.011c-.084,0-.167-.008-.25-.008-.115,0-.229,0-.342.005l-.034,0c-.111.006-.221.017-.33.029l-.1.011c-.12.016-.238.035-.354.059-.031.006-.061.015-.092.021-.093.021-.186.043-.278.069-.044.013-.088.028-.132.042-.073.023-.146.046-.218.072-.088.033-.174.069-.26.106-.042.018-.084.034-.125.054-.126.059-.249.122-.368.191l90.966-52.554c.119-.069.241-.131.366-.19.042-.02.085-.036.127-.054a6.307,6.307,0,0,1,4.39-.01,12.99,12.99,0,0,1,3.9,2.16l.1.084.2.163a21.524,21.524,0,0,1,7.65,14.473,9.506,9.506,0,0,1-1.107,5.678l-.013.02c-.015.023-.03.044-.045.067-.055.082-.111.163-.168.24l-.071.093q-.082.106-.169.207c-.022.026-.043.052-.066.077-.079.089-.161.175-.245.257l-.037.033c-.073.07-.149.137-.226.2-.028.024-.057.046-.085.069q-.1.079-.2.153c-.028.02-.056.041-.084.06-.1.065-.193.128-.292.186l-90.964,52.553c.1-.058.2-.121.292-.186l.084-.061C982.786,587.377,982.853,587.326,982.919,587.273Z",
  transform: "translate(-965.544 -510.506)",
  fill: "#d3d3d3"
}), React.createElement("g", {
  id: "Group_22",
  "data-name": "Group 22",
  transform: "translate(0 52.534)"
}, React.createElement("path", {
  id: "Path_39",
  "data-name": "Path 39",
  d: "M970.534,653.685c5.43,3.135,9.818,10.736,9.8,16.976s-4.434,8.757-9.865,5.622-9.818-10.735-9.8-16.975S965.1,650.55,970.534,653.685Z",
  transform: "translate(-960.669 -652.336)",
  fill: "#b2afad"
})), React.createElement("path", {
  id: "Path_40",
  "data-name": "Path 40",
  d: "M1007.669,595.648c.021.056.043.113.063.169q.1.261.184.521l.015.044c.063.189.123.378.18.567.018.061.036.122.053.183q.058.2.111.39c.02.072.038.144.057.217.031.122.062.243.091.364q.025.108.05.216c.029.125.055.25.08.375.013.066.027.132.04.2q.047.245.087.489c0,.024.008.048.012.071.03.186.055.372.078.557.007.053.011.106.017.158.015.133.029.265.04.4.006.064.01.127.015.19q.014.188.023.375c0,.06.006.12.008.179.006.177.011.353.01.528s-.006.363-.013.54c0,.05-.006.1-.01.149-.007.121-.015.242-.026.36-.006.069-.014.136-.021.2-.011.1-.023.2-.036.3-.01.073-.021.144-.032.215q-.021.135-.046.267c-.015.079-.031.157-.047.235s-.035.158-.053.235-.046.181-.07.269c-.019.069-.039.138-.06.206-.032.106-.067.21-.1.312-.023.064-.044.129-.069.192-.012.031-.024.063-.037.094-.043.106-.087.21-.133.312-.009.02-.017.04-.027.06-.059.127-.122.251-.188.37s-.135.235-.207.346l-.045.066q-.082.124-.169.241l-.071.093q-.082.107-.17.207l-.066.077c-.079.089-.161.175-.245.257l-.036.033q-.111.105-.226.2l-.085.069c-.066.053-.133.1-.2.152l-.084.061c-.1.065-.192.128-.292.186l90.964-52.553c.1-.058.2-.121.292-.186.028-.019.056-.04.084-.06q.1-.073.2-.153l.085-.069c.077-.065.152-.132.226-.2l.037-.033c.084-.082.166-.168.245-.257.023-.025.044-.051.066-.077.058-.067.115-.136.169-.207l.071-.093c.058-.078.114-.158.169-.24.015-.023.03-.044.045-.067l.013-.02a9.507,9.507,0,0,0,1.107-5.678,19.264,19.264,0,0,0-1.156-5.227L1007.652,595.6Z",
  transform: "translate(-989.22 -530.977)",
  fill: "#c6c6c6"
})), React.createElement("g", {
  id: "Group_24",
  "data-name": "Group 24",
  transform: "translate(2.205 55.371)"
}, React.createElement("path", {
  id: "Path_41",
  "data-name": "Path 41",
  d: "M974.275,661.041a16.757,16.757,0,0,1,7.6,13.168c-.013,4.84-3.44,6.793-7.652,4.361a16.757,16.757,0,0,1-7.6-13.168C966.637,660.561,970.063,658.609,974.275,661.041Z",
  transform: "translate(-966.623 -659.995)",
  fill: "#755b6c"
})))), React.createElement("g", {
  id: "Group_37",
  "data-name": "Group 37",
  transform: "translate(808.668 461.847)"
}, React.createElement("g", {
  id: "Group_27",
  "data-name": "Group 27",
  transform: "translate(0 24.081)"
}, React.createElement("path", {
  id: "Path_42",
  "data-name": "Path 42",
  d: "M1519.719,817.371v7.072l19.73-11.377v-7.072Z",
  transform: "translate(-1484.462 -785.636)",
  fill: "#bbb7bc"
}), React.createElement("path", {
  id: "Path_43",
  "data-name": "Path 43",
  d: "M1459.79,802.1v7.072l-35.258-20.359v-7.071Z",
  transform: "translate(-1424.532 -770.369)",
  fill: "#a29fa3"
}), React.createElement("path", {
  id: "Path_44",
  "data-name": "Path 44",
  d: "M1479.52,771.39l-19.73,11.377-35.258-20.359,19.73-11.376Z",
  transform: "translate(-1424.532 -751.032)",
  fill: "#d3d3d3"
})), React.createElement("g", {
  id: "Group_28",
  "data-name": "Group 28",
  transform: "translate(0 16.054)"
}, React.createElement("path", {
  id: "Path_45",
  "data-name": "Path 45",
  d: "M1519.719,795.7v7.071l19.73-11.377v-7.071Z",
  transform: "translate(-1484.462 -763.965)",
  fill: "#bbb7bc"
}), React.createElement("path", {
  id: "Path_46",
  "data-name": "Path 46",
  d: "M1459.79,780.434v7.071l-35.258-20.359v-7.071Z",
  transform: "translate(-1424.532 -748.699)",
  fill: "#a29fa3"
}), React.createElement("path", {
  id: "Path_47",
  "data-name": "Path 47",
  d: "M1479.52,749.72,1459.79,761.1l-35.258-20.359,19.73-11.377Z",
  transform: "translate(-1424.532 -729.361)",
  fill: "#d3d3d3"
})), React.createElement("g", {
  id: "Group_29",
  "data-name": "Group 29",
  transform: "translate(0 8.027)"
}, React.createElement("path", {
  id: "Path_48",
  "data-name": "Path 48",
  d: "M1519.719,774.03V781.1l19.73-11.377v-7.071Z",
  transform: "translate(-1484.462 -742.294)",
  fill: "#bbb7bc"
}), React.createElement("path", {
  id: "Path_49",
  "data-name": "Path 49",
  d: "M1459.79,758.763v7.071l-35.258-20.359V738.4Z",
  transform: "translate(-1424.532 -727.028)",
  fill: "#a29fa3"
}), React.createElement("path", {
  id: "Path_50",
  "data-name": "Path 50",
  d: "M1479.52,728.049l-19.73,11.377-35.258-20.359,19.73-11.377Z",
  transform: "translate(-1424.532 -707.69)",
  fill: "#d3d3d3"
})), React.createElement("g", {
  id: "Group_30",
  "data-name": "Group 30",
  transform: "translate(0 0)"
}, React.createElement("path", {
  id: "Path_51",
  "data-name": "Path 51",
  d: "M1519.719,752.359v7.072l19.73-11.377v-7.072Z",
  transform: "translate(-1484.462 -720.623)",
  fill: "#bbb7bc"
}), React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M1459.79,737.092v7.072L1424.532,723.8v-7.071Z",
  transform: "translate(-1424.532 -705.356)",
  fill: "#a29fa3"
}), React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  d: "M1479.52,706.377l-19.73,11.377L1424.532,697.4l19.73-11.377Z",
  transform: "translate(-1424.532 -686.019)",
  fill: "#d3d3d3"
})), React.createElement("g", {
  id: "Group_31",
  "data-name": "Group 31",
  transform: "translate(36.21 45.074)"
}, React.createElement("path", {
  id: "Path_54",
  "data-name": "Path 54",
  d: "M1617.478,874.049v7.071l19.731-11.377v-7.071Z",
  transform: "translate(-1582.22 -842.313)",
  fill: "#bbb7bc"
}), React.createElement("path", {
  id: "Path_55",
  "data-name": "Path 55",
  d: "M1557.549,858.782v7.071l-35.257-20.359v-7.071Z",
  transform: "translate(-1522.291 -827.046)",
  fill: "#a29fa3"
}), React.createElement("path", {
  id: "Path_56",
  "data-name": "Path 56",
  d: "M1577.279,828.067l-19.73,11.377-35.257-20.359,19.73-11.377Z",
  transform: "translate(-1522.291 -807.709)",
  fill: "#d3d3d3"
})), React.createElement("g", {
  id: "Group_32",
  "data-name": "Group 32",
  transform: "translate(36.21 37.048)"
}, React.createElement("path", {
  id: "Path_57",
  "data-name": "Path 57",
  d: "M1617.478,852.378v7.072l19.731-11.378V841Z",
  transform: "translate(-1582.22 -820.642)",
  fill: "#bbb7bc"
}), React.createElement("path", {
  id: "Path_58",
  "data-name": "Path 58",
  d: "M1557.549,837.111v7.072l-35.257-20.359v-7.071Z",
  transform: "translate(-1522.291 -805.375)",
  fill: "#a29fa3"
}), React.createElement("path", {
  id: "Path_59",
  "data-name": "Path 59",
  d: "M1577.279,806.4l-19.73,11.377-35.257-20.359,19.73-11.376Z",
  transform: "translate(-1522.291 -786.039)",
  fill: "#d3d3d3"
})), React.createElement("g", {
  id: "Group_33",
  "data-name": "Group 33",
  transform: "translate(36.21 29.021)"
}, React.createElement("path", {
  id: "Path_60",
  "data-name": "Path 60",
  d: "M1617.478,830.707v7.072l19.731-11.378V819.33Z",
  transform: "translate(-1582.22 -798.972)",
  fill: "#bbb7bc"
}), React.createElement("path", {
  id: "Path_61",
  "data-name": "Path 61",
  d: "M1557.549,815.44v7.072l-35.257-20.359v-7.071Z",
  transform: "translate(-1522.291 -783.705)",
  fill: "#a29fa3"
}), React.createElement("path", {
  id: "Path_62",
  "data-name": "Path 62",
  d: "M1577.279,784.726l-19.73,11.377-35.257-20.359,19.73-11.377Z",
  transform: "translate(-1522.291 -764.367)",
  fill: "#d3d3d3"
})), React.createElement("g", {
  id: "Group_34",
  "data-name": "Group 34",
  transform: "translate(36.21 20.994)"
}, React.createElement("path", {
  id: "Path_63",
  "data-name": "Path 63",
  d: "M1617.478,809.036v7.071l19.731-11.377v-7.072Z",
  transform: "translate(-1582.22 -777.301)",
  fill: "#bbb7bc"
}), React.createElement("path", {
  id: "Path_64",
  "data-name": "Path 64",
  d: "M1557.549,793.769v7.071l-35.257-20.359V773.41Z",
  transform: "translate(-1522.291 -762.034)",
  fill: "#a29fa3"
}), React.createElement("path", {
  id: "Path_65",
  "data-name": "Path 65",
  d: "M1577.279,763.055l-19.73,11.377-35.257-20.359,19.73-11.377Z",
  transform: "translate(-1522.291 -742.696)",
  fill: "#d3d3d3"
})), React.createElement("g", {
  id: "Group_35",
  "data-name": "Group 35",
  transform: "translate(15.326 57.09)"
}, React.createElement("path", {
  id: "Path_66",
  "data-name": "Path 66",
  d: "M1561.1,906.486v7.071l19.73-11.377v-7.071Z",
  transform: "translate(-1525.839 -874.751)",
  fill: "#bbb7bc"
}), React.createElement("path", {
  id: "Path_67",
  "data-name": "Path 67",
  d: "M1501.167,891.22v7.071l-35.258-20.359v-7.071Z",
  transform: "translate(-1465.909 -859.484)",
  fill: "#a29fa3"
}), React.createElement("path", {
  id: "Path_68",
  "data-name": "Path 68",
  d: "M1520.9,860.5l-19.73,11.377-35.258-20.359,19.73-11.377Z",
  transform: "translate(-1465.909 -840.146)",
  fill: "#d3d3d3"
})), React.createElement("g", {
  id: "Group_36",
  "data-name": "Group 36",
  transform: "translate(15.326 49.062)"
}, React.createElement("path", {
  id: "Path_69",
  "data-name": "Path 69",
  d: "M1561.1,884.815v7.072l19.73-11.377v-7.072Z",
  transform: "translate(-1525.839 -853.08)",
  fill: "#bbb7bc"
}), React.createElement("path", {
  id: "Path_70",
  "data-name": "Path 70",
  d: "M1501.167,869.549v7.071l-35.258-20.359V849.19Z",
  transform: "translate(-1465.909 -837.813)",
  fill: "#a29fa3"
}), React.createElement("path", {
  id: "Path_71",
  "data-name": "Path 71",
  d: "M1520.9,838.834l-19.73,11.377-35.258-20.359,19.73-11.377Z",
  transform: "translate(-1465.909 -818.475)",
  fill: "#d3d3d3"
}))), React.createElement("g", {
  id: "Group_41",
  "data-name": "Group 41",
  transform: "translate(569.406 488.835)"
}, React.createElement("g", {
  id: "Group_38",
  "data-name": "Group 38",
  transform: "translate(0 12.085)"
}, React.createElement("path", {
  id: "Path_72",
  "data-name": "Path 72",
  d: "M865.675,866.535l-87.083-50.324V820.1l87.083,50.272Z",
  transform: "translate(-778.589 -807.059)",
  fill: "#95869b"
}), React.createElement("path", {
  id: "Path_73",
  "data-name": "Path 73",
  d: "M794.39,791.5l-15.806,9.154,87.083,50.324L881.52,841.8Z",
  transform: "translate(-778.584 -791.505)",
  fill: "#bcafc0"
}), React.createElement("path", {
  id: "Path_74",
  "data-name": "Path 74",
  d: "M1029.54,927.294l-15.853,9.182,0,3.834,15.85-9.126Z",
  transform: "translate(-926.603 -876.997)",
  fill: "#a493aa"
})), React.createElement("g", {
  id: "Group_39",
  "data-name": "Group 39",
  transform: "translate(6.14 6.142)"
}, React.createElement("path", {
  id: "Path_75",
  "data-name": "Path 75",
  d: "M882.251,834.617l-87.083-50.325v8.424l87.083,50.272Z",
  transform: "translate(-795.165 -781.021)",
  fill: "#7d6e84"
}), React.createElement("path", {
  id: "Path_76",
  "data-name": "Path 76",
  d: "M800.735,775.461l-5.575,3.275,87.083,50.324,5.621-3.3Z",
  transform: "translate(-795.16 -775.461)",
  fill: "#fcfdff"
}), React.createElement("path", {
  id: "Path_77",
  "data-name": "Path 77",
  d: "M1035.886,911.25l-5.622,3.3,0,8.369,5.619-3.246Z",
  transform: "translate(-943.18 -860.953)",
  fill: "#a493aa"
})), React.createElement("g", {
  id: "Group_40",
  "data-name": "Group 40",
  transform: "translate(0)"
}, React.createElement("path", {
  id: "Path_78",
  "data-name": "Path 78",
  d: "M865.675,833.908l-87.083-50.324v3.889l87.083,50.272Z",
  transform: "translate(-778.589 -774.433)",
  fill: "#95869b"
}), React.createElement("path", {
  id: "Path_79",
  "data-name": "Path 79",
  d: "M794.39,758.879l-15.806,9.154,87.083,50.324,15.853-9.181Z",
  transform: "translate(-778.584 -758.879)",
  fill: "#bcafc0"
}), React.createElement("path", {
  id: "Path_80",
  "data-name": "Path 80",
  d: "M1029.54,894.668l-15.853,9.182,0,3.833,15.85-9.125Z",
  transform: "translate(-926.603 -844.371)",
  fill: "#a493aa"
}))), React.createElement("g", {
  id: "Group_45",
  "data-name": "Group 45",
  transform: "translate(549.379 500.44)"
}, React.createElement("g", {
  id: "Group_42",
  "data-name": "Group 42",
  transform: "translate(0 12.085)"
}, React.createElement("path", {
  id: "Path_81",
  "data-name": "Path 81",
  d: "M811.61,897.868l-87.083-50.324v3.889L811.61,901.7Z",
  transform: "translate(-724.524 -838.393)",
  fill: "#95869b"
}), React.createElement("path", {
  id: "Path_82",
  "data-name": "Path 82",
  d: "M740.324,822.838l-15.806,9.154L811.6,882.316l15.853-9.181Z",
  transform: "translate(-724.518 -822.838)",
  fill: "#bcafc0"
}), React.createElement("path", {
  id: "Path_83",
  "data-name": "Path 83",
  d: "M975.475,958.627l-15.853,9.182,0,3.834,15.851-9.126Z",
  transform: "translate(-872.538 -908.33)",
  fill: "#a493aa"
})), React.createElement("g", {
  id: "Group_43",
  "data-name": "Group 43",
  transform: "translate(6.14 6.142)"
}, React.createElement("path", {
  id: "Path_84",
  "data-name": "Path 84",
  d: "M828.186,865.95,741.1,815.626v8.424l87.083,50.272Z",
  transform: "translate(-741.1 -812.355)",
  fill: "#7d6e84"
}), React.createElement("path", {
  id: "Path_85",
  "data-name": "Path 85",
  d: "M746.67,806.794l-5.575,3.274,87.083,50.325,5.622-3.3Z",
  transform: "translate(-741.095 -806.794)",
  fill: "#fcfdff"
}), React.createElement("path", {
  id: "Path_86",
  "data-name": "Path 86",
  d: "M981.821,942.583l-5.622,3.3,0,8.369,5.62-3.246Z",
  transform: "translate(-889.115 -892.286)",
  fill: "#a493aa"
})), React.createElement("g", {
  id: "Group_44",
  "data-name": "Group 44",
  transform: "translate(0)"
}, React.createElement("path", {
  id: "Path_87",
  "data-name": "Path 87",
  d: "M811.61,865.242l-87.083-50.324v3.889l87.083,50.272Z",
  transform: "translate(-724.524 -805.766)",
  fill: "#95869b"
}), React.createElement("path", {
  id: "Path_88",
  "data-name": "Path 88",
  d: "M740.324,790.212l-15.806,9.154L811.6,849.69l15.853-9.181Z",
  transform: "translate(-724.518 -790.212)",
  fill: "#bcafc0"
}), React.createElement("path", {
  id: "Path_89",
  "data-name": "Path 89",
  d: "M975.475,926l-15.853,9.182,0,3.834,15.851-9.125Z",
  transform: "translate(-872.538 -875.704)",
  fill: "#a493aa"
}))), React.createElement("g", {
  id: "Group_49",
  "data-name": "Group 49",
  transform: "translate(529.354 512.047)"
}, React.createElement("g", {
  id: "Group_46",
  "data-name": "Group 46",
  transform: "translate(0 12.085)"
}, React.createElement("path", {
  id: "Path_90",
  "data-name": "Path 90",
  d: "M757.544,929.2l-87.083-50.324v3.889l87.083,50.272Z",
  transform: "translate(-670.458 -869.726)",
  fill: "#95869b"
}), React.createElement("path", {
  id: "Path_91",
  "data-name": "Path 91",
  d: "M686.259,854.171l-15.806,9.154,87.083,50.324,15.853-9.181Z",
  transform: "translate(-670.453 -854.171)",
  fill: "#bcafc0"
}), React.createElement("path", {
  id: "Path_92",
  "data-name": "Path 92",
  d: "M921.41,989.96l-15.853,9.182,0,3.834,15.85-9.126Z",
  transform: "translate(-818.473 -939.663)",
  fill: "#a493aa"
})), React.createElement("g", {
  id: "Group_47",
  "data-name": "Group 47",
  transform: "translate(6.14 6.142)"
}, React.createElement("path", {
  id: "Path_93",
  "data-name": "Path 93",
  d: "M774.121,897.284l-87.083-50.324v8.424l87.083,50.272Z",
  transform: "translate(-687.035 -843.688)",
  fill: "#7d6e84"
}), React.createElement("path", {
  id: "Path_94",
  "data-name": "Path 94",
  d: "M692.6,838.128,687.03,841.4l87.083,50.324,5.622-3.3Z",
  transform: "translate(-687.03 -838.128)",
  fill: "#fcfdff"
}), React.createElement("path", {
  id: "Path_95",
  "data-name": "Path 95",
  d: "M927.755,973.916l-5.622,3.3,0,8.369,5.619-3.246Z",
  transform: "translate(-835.05 -923.62)",
  fill: "#a493aa"
})), React.createElement("g", {
  id: "Group_48",
  "data-name": "Group 48",
  transform: "translate(0)"
}, React.createElement("path", {
  id: "Path_96",
  "data-name": "Path 96",
  d: "M757.544,896.575l-87.083-50.324v3.889l87.083,50.272Z",
  transform: "translate(-670.458 -837.1)",
  fill: "#95869b"
}), React.createElement("path", {
  id: "Path_97",
  "data-name": "Path 97",
  d: "M686.259,821.545,670.453,830.7l87.083,50.324,15.853-9.181Z",
  transform: "translate(-670.453 -821.545)",
  fill: "#bcafc0"
}), React.createElement("path", {
  id: "Path_98",
  "data-name": "Path 98",
  d: "M921.41,957.334l-15.853,9.181,0,3.834,15.85-9.125Z",
  transform: "translate(-818.473 -907.037)",
  fill: "#a493aa"
}))), React.createElement("g", {
  id: "Group_50",
  "data-name": "Group 50",
  transform: "translate(737.939 441.572)"
}, React.createElement("path", {
  id: "Path_99",
  "data-name": "Path 99",
  d: "M1254.167,677.93l-20.574-12.009v56.907l20.574,11.935Z",
  transform: "translate(-1233.589 -653.091)",
  fill: "#f3a81e"
}), React.createElement("path", {
  id: "Path_100",
  "data-name": "Path 100",
  d: "M1255.743,631.283l-22.161,12.834,20.574,12.009,22.226-12.872Z",
  transform: "translate(-1233.582 -631.283)",
  fill: "#f9d35f"
}), React.createElement("path", {
  id: "Path_101",
  "data-name": "Path 101",
  d: "M1311.353,663.6l-22.227,12.873,0,56.829,22.223-12.794Z",
  transform: "translate(-1268.553 -651.629)",
  fill: "#fbc90b"
})), React.createElement("g", {
  id: "Group_51",
  "data-name": "Group 51",
  transform: "translate(677.229 329.962)"
}, React.createElement("path", {
  id: "Path_102",
  "data-name": "Path 102",
  d: "M1077.2,347l-7.514-4.386v23l7.514,4.359Z",
  transform: "translate(-1069.683 -337.926)",
  fill: "#d3d3d3"
}), React.createElement("path", {
  id: "Path_103",
  "data-name": "Path 103",
  d: "M1077.773,329.962l-8.093,4.687,7.514,4.386,8.117-4.7Z",
  transform: "translate(-1069.68 -329.962)",
  fill: "#fcfdff"
}), React.createElement("path", {
  id: "Path_104",
  "data-name": "Path 104",
  d: "M1098.082,341.764l-8.117,4.7v22.976l8.116-4.672Z",
  transform: "translate(-1082.452 -337.392)",
  fill: "#e0e4e4"
})), React.createElement("g", {
  id: "Group_52",
  "data-name": "Group 52",
  transform: "translate(639.583 351.678)"
}, React.createElement("path", {
  id: "Path_105",
  "data-name": "Path 105",
  d: "M975.562,405.627l-7.514-4.386v23l7.514,4.359Z",
  transform: "translate(-968.047 -396.556)",
  fill: "#d3d3d3"
}), React.createElement("path", {
  id: "Path_106",
  "data-name": "Path 106",
  d: "M976.138,388.591l-8.093,4.687,7.514,4.386,8.117-4.7Z",
  transform: "translate(-968.045 -388.591)",
  fill: "#fcfdff"
}), React.createElement("path", {
  id: "Path_107",
  "data-name": "Path 107",
  d: "M996.447,400.393l-8.117,4.7v22.977l8.116-4.672Z",
  transform: "translate(-980.816 -396.022)",
  fill: "#e0e4e4"
})), React.createElement("g", {
  id: "Group_53",
  "data-name": "Group 53",
  transform: "translate(601.936 373.395)"
}, React.createElement("path", {
  id: "Path_108",
  "data-name": "Path 108",
  d: "M873.927,464.256l-7.514-4.386v23l7.514,4.359Z",
  transform: "translate(-866.411 -455.184)",
  fill: "#d3d3d3"
}), React.createElement("path", {
  id: "Path_109",
  "data-name": "Path 109",
  d: "M874.5,447.22l-8.093,4.687,7.514,4.386,8.117-4.7Z",
  transform: "translate(-866.409 -447.22)",
  fill: "#fcfdff"
}), React.createElement("path", {
  id: "Path_110",
  "data-name": "Path 110",
  d: "M894.811,459.022l-8.117,4.7V486.7l8.116-4.672Z",
  transform: "translate(-879.18 -454.651)",
  fill: "#e0e4e4"
})), React.createElement("g", {
  id: "Group_54",
  "data-name": "Group 54",
  transform: "translate(564.29 395.111)"
}, React.createElement("path", {
  id: "Path_111",
  "data-name": "Path 111",
  d: "M772.291,522.885l-7.514-4.386v23l7.514,4.359Z",
  transform: "translate(-764.776 -513.813)",
  fill: "#d3d3d3"
}), React.createElement("path", {
  id: "Path_112",
  "data-name": "Path 112",
  d: "M772.867,505.849l-8.093,4.687,7.514,4.386,8.117-4.7Z",
  transform: "translate(-764.773 -505.849)",
  fill: "#fcfdff"
}), React.createElement("path", {
  id: "Path_113",
  "data-name": "Path 113",
  d: "M793.176,517.651l-8.117,4.7v22.976l8.116-4.672Z",
  transform: "translate(-777.545 -513.28)",
  fill: "#e0e4e4"
})), React.createElement("g", {
  id: "Group_55",
  "data-name": "Group 55",
  transform: "translate(526.644 416.828)"
}, React.createElement("path", {
  id: "Path_114",
  "data-name": "Path 114",
  d: "M670.656,581.514l-7.513-4.386v23l7.513,4.359Z",
  transform: "translate(-663.141 -572.443)",
  fill: "#d3d3d3"
}), React.createElement("path", {
  id: "Path_115",
  "data-name": "Path 115",
  d: "M671.231,564.478l-8.093,4.687,7.514,4.386,8.117-4.7Z",
  transform: "translate(-663.138 -564.478)",
  fill: "#fcfdff"
}), React.createElement("path", {
  id: "Path_116",
  "data-name": "Path 116",
  d: "M691.54,576.281l-8.117,4.7v22.977l8.116-4.672Z",
  transform: "translate(-675.909 -571.909)",
  fill: "#e0e4e4"
})), React.createElement("g", {
  id: "Group_56",
  "data-name": "Group 56",
  transform: "translate(488.998 438.544)"
}, React.createElement("path", {
  id: "Path_117",
  "data-name": "Path 117",
  d: "M569.02,640.143l-7.513-4.386v23l7.513,4.359Z",
  transform: "translate(-561.505 -631.072)",
  fill: "#d3d3d3"
}), React.createElement("path", {
  id: "Path_118",
  "data-name": "Path 118",
  d: "M569.6,623.107l-8.093,4.687,7.514,4.386,8.117-4.7Z",
  transform: "translate(-561.502 -623.107)",
  fill: "#fcfdff"
}), React.createElement("path", {
  id: "Path_119",
  "data-name": "Path 119",
  d: "M589.9,634.909l-8.117,4.7v22.976l8.116-4.672Z",
  transform: "translate(-574.274 -630.538)",
  fill: "#e0e4e4"
})), React.createElement("g", {
  id: "Group_57",
  "data-name": "Group 57",
  transform: "translate(451.352 460.261)"
}, React.createElement("path", {
  id: "Path_120",
  "data-name": "Path 120",
  d: "M467.385,698.772l-7.514-4.386v23l7.514,4.359Z",
  transform: "translate(-459.87 -689.7)",
  fill: "#d3d3d3"
}), React.createElement("path", {
  id: "Path_121",
  "data-name": "Path 121",
  d: "M467.96,681.736l-8.093,4.687,7.514,4.386,8.117-4.7Z",
  transform: "translate(-459.867 -681.736)",
  fill: "#fcfdff"
}), React.createElement("path", {
  id: "Path_122",
  "data-name": "Path 122",
  d: "M488.269,693.539l-8.117,4.7v22.976l8.116-4.672Z",
  transform: "translate(-472.639 -689.167)",
  fill: "#e0e4e4"
})), React.createElement("g", {
  id: "Group_58",
  "data-name": "Group 58",
  transform: "translate(769.051 459.615)"
}, React.createElement("path", {
  id: "Path_123",
  "data-name": "Path 123",
  d: "M1338.161,726.641l-20.574-12.009v56.907l20.574,11.935Z",
  transform: "translate(-1317.583 -701.802)",
  fill: "#f3a81e"
}), React.createElement("path", {
  id: "Path_124",
  "data-name": "Path 124",
  d: "M1339.737,679.993l-22.161,12.835,20.574,12.009,22.226-12.872Z",
  transform: "translate(-1317.577 -679.993)",
  fill: "#f9d35f"
}), React.createElement("path", {
  id: "Path_125",
  "data-name": "Path 125",
  d: "M1395.347,712.311l-22.227,12.873,0,56.829,22.223-12.794Z",
  transform: "translate(-1352.547 -700.34)",
  fill: "#fbc90b"
})), React.createElement("g", {
  id: "Group_62",
  "data-name": "Group 62",
  transform: "translate(663.656 514.448)"
}, React.createElement("g", {
  id: "Group_59",
  "data-name": "Group 59",
  transform: "translate(0 12.085)"
}, React.createElement("path", {
  id: "Path_126",
  "data-name": "Path 126",
  d: "M1075.828,935.685l87.083-50.324v3.889l-87.083,50.272Z",
  transform: "translate(-1059.978 -876.21)",
  fill: "#95869b"
}), React.createElement("path", {
  id: "Path_127",
  "data-name": "Path 127",
  d: "M1120.168,860.656l15.806,9.154-87.083,50.324-15.852-9.181Z",
  transform: "translate(-1033.038 -860.656)",
  fill: "#bcafc0"
}), React.createElement("path", {
  id: "Path_128",
  "data-name": "Path 128",
  d: "M1033.037,996.444l15.853,9.182,0,3.833-15.85-9.125Z",
  transform: "translate(-1033.037 -946.148)",
  fill: "#a493aa"
})), React.createElement("g", {
  id: "Group_60",
  "data-name": "Group 60",
  transform: "translate(4.091 6.142)"
}, React.createElement("path", {
  id: "Path_129",
  "data-name": "Path 129",
  d: "M1059.252,903.768l87.083-50.324v8.424l-87.083,50.272Z",
  transform: "translate(-1053.633 -850.172)",
  fill: "#7d6e84"
}), React.createElement("path", {
  id: "Path_130",
  "data-name": "Path 130",
  d: "M1131.213,844.612l5.575,3.274L1049.7,898.211l-5.621-3.3Z",
  transform: "translate(-1044.083 -844.612)",
  fill: "#fcfdff"
}), React.createElement("path", {
  id: "Path_131",
  "data-name": "Path 131",
  d: "M1044.081,980.4l5.622,3.3,0,8.369-5.619-3.246Z",
  transform: "translate(-1044.081 -930.104)",
  fill: "#a493aa"
})), React.createElement("g", {
  id: "Group_61",
  "data-name": "Group 61"
}, React.createElement("path", {
  id: "Path_132",
  "data-name": "Path 132",
  d: "M1075.828,903.059l87.083-50.324v3.889L1075.828,906.9Z",
  transform: "translate(-1059.978 -843.584)",
  fill: "#95869b"
}), React.createElement("path", {
  id: "Path_133",
  "data-name": "Path 133",
  d: "M1120.168,828.029l15.806,9.154-87.083,50.324-15.852-9.181Z",
  transform: "translate(-1033.038 -828.029)",
  fill: "#bcafc0"
}), React.createElement("path", {
  id: "Path_134",
  "data-name": "Path 134",
  d: "M1033.037,963.818,1048.89,973l0,3.834-15.85-9.126Z",
  transform: "translate(-1033.037 -913.521)",
  fill: "#a493aa"
}))), React.createElement("g", {
  id: "Group_64",
  "data-name": "Group 64",
  transform: "translate(666.585 561.975)"
}, React.createElement("path", {
  id: "Path_135",
  "data-name": "Path 135",
  d: "M1155.271,1098.684l123.508-71.316c-.917-.958-1.851-1.88-2.722-2.77-5.036-5.145-11.709-5.526-17.538-9.189-4.481-2.815-7.176-7.662-10.3-11.94-8.34-11.413-24.575-9.119-36.089-16.318-16.686-10.431-20-21.063-39.789-25.811-13.988-3.357-29.322-10.733-45.443,3.042-2.822,2.411-11,11.9-13.544,14.6-6.606,7.018-19.121,5.68-25.4,12.994-4.94,5.758-5.113,13.538-11.157,18.647-7.251,6.129-18.056,6.523-25.879,11.791-4.229,2.848-7.884,6.232-9.977,10.2Z",
  transform: "translate(-1040.945 -956.341)",
  fill: "#313c48"
}), React.createElement("g", {
  id: "Group_63",
  "data-name": "Group 63",
  transform: "translate(21.385 11.429)"
}, React.createElement("path", {
  id: "Path_136",
  "data-name": "Path 136",
  d: "M1276.5,1065.738c1.041,0,1.691-.26,1.756-1.235s-1.366-2.341-1.366-2.341c-1.5-.455-2.731,1.43-3.186,1.788S1275.46,1065.738,1276.5,1065.738Z",
  transform: "translate(-1208.836 -1034.35)",
  fill: "#4d5a66"
}), React.createElement("path", {
  id: "Path_137",
  "data-name": "Path 137",
  d: "M1446.107,1124.3c-1.5-.455-2.731,1.431-3.186,1.788s1.756,1.788,2.8,1.788,1.691-.26,1.755-1.235S1446.107,1124.3,1446.107,1124.3Z",
  transform: "translate(-1315.374 -1073.473)",
  fill: "#4d5a66"
}), React.createElement("path", {
  id: "Path_138",
  "data-name": "Path 138",
  d: "M1354.344,1090.458c-2.215-.675-4.046,2.119-4.72,2.649s2.6,2.649,4.142,2.649,2.5-.385,2.6-1.83S1354.344,1090.458,1354.344,1090.458Z",
  transform: "translate(-1256.616 -1052.143)",
  fill: "#4d5a66"
}), React.createElement("path", {
  id: "Path_139",
  "data-name": "Path 139",
  d: "M1104,1160.749c-2.4-.729-4.373,2.291-5.1,2.863s2.811,2.864,4.478,2.864,2.707-.416,2.811-1.979S1104,1160.749,1104,1160.749Z",
  transform: "translate(-1098.757 -1096.393)",
  fill: "#4d5a66"
}), React.createElement("path", {
  id: "Path_140",
  "data-name": "Path 140",
  d: "M1200.326,1222.92c-1.5-.455-2.731,1.431-3.186,1.788s1.756,1.788,2.8,1.788,1.691-.26,1.756-1.236S1200.326,1222.92,1200.326,1222.92Z",
  transform: "translate(-1160.631 -1135.563)",
  fill: "#4d5a66"
}), React.createElement("path", {
  id: "Path_141",
  "data-name": "Path 141",
  d: "M1420.829,1009.9c-1.5-.455-2.731,1.43-3.186,1.788s1.756,1.788,2.8,1.788,1.69-.26,1.756-1.235S1420.829,1009.9,1420.829,1009.9Z",
  transform: "translate(-1299.459 -1001.444)",
  fill: "#4d5a66"
}), React.createElement("path", {
  id: "Path_142",
  "data-name": "Path 142",
  d: "M1395.884,1028.418l.78-.342v-.683h-.536C1395.153,1027.833,1395.884,1028.418,1395.884,1028.418Z",
  transform: "translate(-1285.632 -1012.505)",
  fill: "#4d5a66"
}), React.createElement("path", {
  id: "Path_143",
  "data-name": "Path 143",
  d: "M1268.855,1039.486l.78-.341v-.683h-.536C1268.124,1038.9,1268.855,1039.486,1268.855,1039.486Z",
  transform: "translate(-1205.656 -1019.473)",
  fill: "#4d5a66"
}), React.createElement("path", {
  id: "Path_144",
  "data-name": "Path 144",
  d: "M1180.821,1146.965l1.457-.637v-1.275h-1C1179.455,1145.872,1180.821,1146.965,1180.821,1146.965Z",
  transform: "translate(-1150.086 -1086.582)",
  fill: "#4d5a66"
}), React.createElement("path", {
  id: "Path_145",
  "data-name": "Path 145",
  d: "M1099.171,1135.988l1.457-.637v-1.275h-1C1097.8,1134.9,1099.171,1135.988,1099.171,1135.988Z",
  transform: "translate(-1098.679 -1079.671)",
  fill: "#4d5a66"
}), React.createElement("path", {
  id: "Path_146",
  "data-name": "Path 146",
  d: "M1570.847,1134.963l1.457-.637v-1.275h-1C1569.482,1133.87,1570.847,1134.963,1570.847,1134.963Z",
  transform: "translate(-1395.645 -1079.026)",
  fill: "#4d5a66"
}), React.createElement("path", {
  id: "Path_147",
  "data-name": "Path 147",
  d: "M1490.038,1083.923l1.457-.637v-1.275h-1C1488.672,1082.83,1490.038,1083.923,1490.038,1083.923Z",
  transform: "translate(-1344.767 -1046.891)",
  fill: "#4d5a66"
}), React.createElement("path", {
  id: "Path_148",
  "data-name": "Path 148",
  d: "M1490.038,1183.675l1.457-.638v-1.275h-1C1488.672,1182.582,1490.038,1183.675,1490.038,1183.675Z",
  transform: "translate(-1344.767 -1109.694)",
  fill: "#4d5a66"
}), React.createElement("path", {
  id: "Path_149",
  "data-name": "Path 149",
  d: "M1378.117,1247.433l1.457-.637v-1.275h-1C1376.752,1246.341,1378.117,1247.433,1378.117,1247.433Z",
  transform: "translate(-1274.303 -1149.836)",
  fill: "#4d5a66"
}), React.createElement("path", {
  id: "Path_150",
  "data-name": "Path 150",
  d: "M1275.7,1161.011a4.622,4.622,0,0,0-3.074,1.053c-3.244,2.613,2.464,2.845,3.075,2.845s3.028-1.429,3.074-1.949S1277.429,1161.141,1275.7,1161.011Z",
  transform: "translate(-1207.572 -1096.623)",
  fill: "#4d5a66"
}), React.createElement("path", {
  id: "Path_151",
  "data-name": "Path 151",
  d: "M1330.147,987.206a4.621,4.621,0,0,0-3.074,1.053c-3.244,2.613,2.463,2.845,3.075,2.845s3.028-1.43,3.074-1.95S1331.876,987.336,1330.147,987.206Z",
  transform: "translate(-1241.851 -987.196)",
  fill: "#4d5a66"
}), React.createElement("path", {
  id: "Path_152",
  "data-name": "Path 152",
  d: "M1460.851,1219.064a4.622,4.622,0,0,0-.733,3.166c.5,4.135,3.718-.585,4.042-1.1s.39-3.325-.027-3.639S1461.876,1217.666,1460.851,1219.064Z",
  transform: "translate(-1326.215 -1132.129)",
  fill: "#4d5a66"
}), React.createElement("path", {
  id: "Path_153",
  "data-name": "Path 153",
  d: "M1606.959,1142.287c-.177-.491-1.987-1.083-3.61-.472a4.623,4.623,0,0,0-2.344,2.252c-1.84,3.736,3.433,1.541,3.987,1.284S1607.136,1142.777,1606.959,1142.287Z",
  transform: "translate(-1414.697 -1084.379)",
  fill: "#4d5a66"
})))), React.createElement("g", {
  id: "Container",
  transform: "translate(-109 121)"
}, React.createElement("g", {
  id: "Group_129",
  "data-name": "Group 129",
  transform: "translate(1141 238)"
}, React.createElement("path", {
  id: "Path_338",
  "data-name": "Path 338",
  d: "M1335.48,831.773V945.781l88.958-51.334V780.442Z",
  transform: "translate(-1063.433 -623.356)",
  fill: "#e0e4e4"
}), React.createElement("path", {
  id: "Path_339",
  "data-name": "Path 339",
  d: "M1335.48,831.774V945.781l88.958-51.334V780.442Zm6.342,3.662,76.273-44.013v99.362L1341.822,934.8Z",
  transform: "translate(-1063.433 -623.356)",
  fill: "#d3d3d3"
}), React.createElement("path", {
  id: "Path_340",
  "data-name": "Path 340",
  d: "M848.822,642.585V756.593L576.775,599.5V485.5Z",
  transform: "translate(-576.775 -434.168)",
  fill: "#d3d3d3"
}), React.createElement("path", {
  id: "Path_341",
  "data-name": "Path 341",
  d: "M937.78,499.435l-88.957,51.331L576.775,393.677l88.955-51.328Z",
  transform: "translate(-576.775 -342.349)",
  fill: "#fcfdff"
}), React.createElement("path", {
  id: "Path_342",
  "data-name": "Path 342",
  d: "M576.775,485.495V599.5L848.822,756.592V642.585Zm6.342,10.985L842.48,646.245v99.362L583.117,595.839Z",
  transform: "translate(-576.775 -434.167)",
  fill: "#c6c6c6"
}), React.createElement("path", {
  id: "Path_343",
  "data-name": "Path 343",
  d: "M576.775,393.677l272.047,157.09,88.958-51.332L665.73,342.349ZM848.822,543.444,589.462,393.679l76.268-44.007L925.093,499.433Z",
  transform: "translate(-576.775 -342.349)",
  fill: "#e0e4e4"
})), React.createElement("g", {
  id: "Group_130",
  "data-name": "Group 130",
  transform: "translate(1349.159 429.927)"
}, React.createElement("path", {
  id: "Path_344",
  "data-name": "Path 344",
  d: "M1193.709,1114.883l-30.318-17.956-6.087,3.527,36.4,21.533Z",
  transform: "translate(-1157.305 -1018.286)",
  fill: "#f1f1f2"
}), React.createElement("path", {
  id: "Path_345",
  "data-name": "Path 345",
  d: "M1174.28,962.534V887.408l30.318,17.659v75.424Z",
  transform: "translate(-1168.193 -883.894)",
  fill: "#536276"
}), React.createElement("path", {
  id: "Path_346",
  "data-name": "Path 346",
  d: "M1157.307,877.609v82.167l6.086-3.527V881.122Z",
  transform: "translate(-1157.306 -877.609)",
  fill: "#e0e4e4"
})), React.createElement("g", {
  id: "Group_131",
  "data-name": "Group 131",
  transform: "translate(1302.111 402.794)"
}, React.createElement("path", {
  id: "Path_347",
  "data-name": "Path 347",
  d: "M1056.242,909.2l-25.109-14.872-5.041,2.921,30.15,17.834Z",
  transform: "translate(-1026.092 -861.203)",
  fill: "#f1f1f2"
}), React.createElement("path", {
  id: "Path_348",
  "data-name": "Path 348",
  d: "M1040.151,840.274v-30.22l25.109,14.626v30.466Z",
  transform: "translate(-1035.11 -807.144)",
  fill: "#536276"
}), React.createElement("path", {
  id: "Path_349",
  "data-name": "Path 349",
  d: "M1026.093,801.939v36.05l5.041-2.921v-30.22Z",
  transform: "translate(-1026.093 -801.939)",
  fill: "#e0e4e4"
})), React.createElement("g", {
  id: "Group_132",
  "data-name": "Group 132",
  transform: "translate(1428.609 424.582)"
}, React.createElement("path", {
  id: "Path_350",
  "data-name": "Path 350",
  d: "M1378.879,986.881l54.627-31.785,5.041,2.921-59.668,34.748Z",
  transform: "translate(-1378.878 -921.966)",
  fill: "#f1f1f2"
}), React.createElement("path", {
  id: "Path_351",
  "data-name": "Path 351",
  d: "M1433.506,901.045v-30.22l-54.627,31.539V932.83Z",
  transform: "translate(-1378.879 -867.912)",
  fill: "#536276"
}), React.createElement("path", {
  id: "Path_352",
  "data-name": "Path 352",
  d: "M1536.267,862.7v36.05l-5.04-2.921v-30.22Z",
  transform: "translate(-1476.599 -862.701)",
  fill: "#d3d3d3"
})), React.createElement("g", {
  id: "Group_133",
  "data-name": "Group 133",
  transform: "translate(1268.674 383.496)"
}, React.createElement("path", {
  id: "Path_353",
  "data-name": "Path 353",
  d: "M962.99,855.384l-25.109-14.872-5.041,2.921,30.151,17.834Z",
  transform: "translate(-932.84 -807.383)",
  fill: "#f1f1f2"
}), React.createElement("path", {
  id: "Path_354",
  "data-name": "Path 354",
  d: "M946.9,786.453v-30.22l25.109,14.626v30.466Z",
  transform: "translate(-941.858 -753.323)",
  fill: "#536276"
}), React.createElement("path", {
  id: "Path_355",
  "data-name": "Path 355",
  d: "M932.843,748.118v36.05l5.04-2.921v-30.22Z",
  transform: "translate(-932.842 -748.118)",
  fill: "#e0e4e4"
})), React.createElement("g", {
  id: "Group_134",
  "data-name": "Group 134",
  transform: "translate(1196.227 341.66)"
}, React.createElement("path", {
  id: "Path_356",
  "data-name": "Path 356",
  d: "M760.947,738.709l-25.109-14.871-5.041,2.921,30.151,17.834Z",
  transform: "translate(-730.796 -690.708)",
  fill: "#f1f1f2"
}), React.createElement("path", {
  id: "Path_357",
  "data-name": "Path 357",
  d: "M744.856,669.777v-30.22l25.109,14.626v30.466Z",
  transform: "translate(-739.815 -636.648)",
  fill: "#536276"
}), React.createElement("path", {
  id: "Path_358",
  "data-name": "Path 358",
  d: "M730.8,631.443v36.05l5.04-2.921v-30.22Z",
  transform: "translate(-730.798 -631.443)",
  fill: "#e0e4e4"
})), React.createElement("g", {
  id: "Group_135",
  "data-name": "Group 135",
  transform: "translate(1162.79 322.361)"
}, React.createElement("path", {
  id: "Path_359",
  "data-name": "Path 359",
  d: "M667.7,684.888l-25.109-14.871-5.041,2.921L667.7,690.771Z",
  transform: "translate(-637.545 -636.887)",
  fill: "#f1f1f2"
}), React.createElement("path", {
  id: "Path_360",
  "data-name": "Path 360",
  d: "M651.605,615.957v-30.22l25.109,14.626v30.466Z",
  transform: "translate(-646.564 -582.827)",
  fill: "#536276"
}), React.createElement("path", {
  id: "Path_361",
  "data-name": "Path 361",
  d: "M637.548,577.622v36.05l5.04-2.921v-30.22Z",
  transform: "translate(-637.547 -577.622)",
  fill: "#e0e4e4"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 676.005,
    height: 501.356,
    viewBox: "0 0 676.005 501.356"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/construction-site.7dfdd02e.svg";
export { SvgComponent as ReactComponent };